module.exports = __webpack_public_path__ + "img/banner-layer4.f2593910.png";